import { useEffect, useRef } from 'react';

const DEBOUNCE_DELAY = 100;

export const useDebouncedSearch = (
  value: string,
  onSearch: (query: string) => void,
  onClear: () => void,
) => {
  const debounceRef = useRef<NodeJS.Timeout>();
  const onSearchRef = useRef(onSearch);
  const onClearRef = useRef(onClear);

  useEffect(() => {
    onSearchRef.current = onSearch;
  }, [onSearch]);

  useEffect(() => {
    onClearRef.current = onClear;
  }, [onClear]);

  useEffect(() => {
    if (value.trim()) {
      if (debounceRef.current && typeof clearTimeout !== 'undefined') {
        clearTimeout(debounceRef.current);
      }

      debounceRef.current = setTimeout(() => {
        onSearchRef.current(value.trim());
      }, DEBOUNCE_DELAY);
    } else {
      onClearRef.current();
    }

    return () => {
      if (debounceRef.current && typeof clearTimeout !== 'undefined') {
        clearTimeout(debounceRef.current);
      }
    };
  }, [value]); // Only depend on value

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (debounceRef.current && typeof clearTimeout !== 'undefined') {
        clearTimeout(debounceRef.current);
      }
    };
  }, []);
};
